import React from "react";
import styled from "styled-components";

export default function LegalSections({ data = {} }) {
  const { mainTitle = "", effectiveDate = "", sections = [] } = data;

  return (
    <PageWrapper>
      <Container>
        <MainTitle>{mainTitle}</MainTitle>
        <EffectiveDate>{effectiveDate}</EffectiveDate>

        {sections.map((section, index) => (
          <Section key={index}>
            <SectionTitle>{section.title}</SectionTitle>

            {section.paragraphs && section.paragraphs.length > 0 ? (
              section.paragraphs.map((para, i) => <Paragraph key={i}>{para}</Paragraph>)
            ) : (
              <BulletList>
                {section.bullets?.map((bullet, i) => <BulletItem key={i}>{bullet}</BulletItem>)}
              </BulletList>
            )}
          </Section>
        ))}
      </Container>
    </PageWrapper>
  );
}

const PageWrapper = styled.div`
  min-height: 100vh;
  background-color: #000000;
  color: #ffffff;
  padding: 48px 16px;
  @media (min-width: 640px) { padding: 64px 24px; }
  @media (min-width: 1024px) { padding: 80px 32px; }
`;

const Container = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 48px 32px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.8);
  @media (min-width: 768px) { padding: 64px 48px; }
`;

const MainTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
  @media (min-width: 640px) { font-size: 3rem; }
`;

const EffectiveDate = styled.p`
  text-align: center;
  color: #aaaaaa;
  font-size: 1.125rem;
  margin-bottom: 48px;
`;

const Section = styled.section`
  margin-bottom: 56px;
  &:last-child { margin-bottom: 0; }
`;

const SectionTitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #444444;
`;

const Paragraph = styled.p`
  color: #dddddd;
  line-height: 1.7;
  margin-bottom: 16px;
  font-size: 1.05rem;
`;

const BulletList = styled.ul`
  list-style: none;
  padding-left: 8px;
  color: #dddddd;
`;

const BulletItem = styled.li`
  display: flex;
  margin-bottom: 12px;
  line-height: 1.7;
  font-size: 1.05rem;
  &::before { content: "•"; color: #888888; margin-right: 12px; flex-shrink: 0; }
`;
